<ng-template [ngIf]="filters.length > 0">
    <div class="selected-filters-container">
        <div class="fluid-container">
            <div class="selected-filters-desktop">
                <ng-container *ngFor="let item of filters; let i = index;">
                    <div class="badge">
                        {{ item.value.code | tfFiltersTruncate }}
                        <span (click)="deleteItem(item)" class="delete">
                <svg width="10px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <line x1="19" y1="5" x2="5" y2="19" fill="#fff" stroke="#000" stroke-width="2" stroke-miterlimit="10" />
                    <line x1="5" y1="5" x2="19" y2="19" fill="#fff" stroke="#000" stroke-width="2" stroke-miterlimit="10" />
                </svg>
            </span>
                    </div>
                </ng-container>
                <ng-container *ngIf="filters.length > 0">
                    <span (click)="deleteAll()" class="clear-all">Clear all</span>
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>
